import Omninano from '../../assets/Image/omni-nano.jpeg';

export const K12 = (
    <div>
        <p className="title"><b>K-12 Curriculum</b></p>
        <p>
            <span className="programs-span"><b>National NanoTechnology Coordinated Infrastructure {"(NNCI)"}</b></span><br />
            We encourage educators to visit the <a href="nano.gov"><span className="nano-gov">nano.gov</span></a> website for existing nationwide resources. A large amount of educational materials and links to nanotechnology networks are available at:
            <br /><br />
            <a href="https://www.nano.gov/education-training"><button className="programs-button">NNCI Educational Resources</button></a>
            <a href="https://www.nnci.net/resources-educators-k-16"><button className="programs-button">Resource for Educators (K-16)</button></a>
            <br /><br />
            <span className="programs-span"><b>Omni Nano</b></span><br />
            <img className="img-fluid" style={{ width: 150, height: 150 }} src={Omninano}></img><br />
            Omni Nano and SDNI are partnering for Nanotechnology curriculum development and educational outreach. We invite you to visit the <a href="https://omninano.org">Omni Nano Website</a>
            <br /><br />
            <span className="programs-span"><b>SDNI</b></span><br />
            The following section will build gradually over the years and contain curriculum and activities that are developed by SDNI or its school/college partners, or jointly with such school/college partners.
            <br /><br />
        </p>
        <table>
            <tbody>
                <tr>
                    <td width="75%" className="text">A Sprinkle of Nano with your Bio?</td>
                    <td with="25%">
                        <a href="https://drive.google.com/file/d/11mmt_kViVQWUBN96DtJR3VRlqR-z5HCT/view?usp=sharing">
                            <button className="programs-small-button">Learn More</button>
                        </a>
                    </td>
                </tr>
                <tr>
                    <td width="75%" className="text">Colors: Wonderful Phenomena</td>
                    <td with="25%">
                        <a href="https://drive.google.com/file/d/1bzWZt4ClP-qsIlwu7CkdWhJuTJgfYEM5/view?ts=5edfc4c6">
                            <button className="programs-small-button">Learn More</button>
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
        <br /><br />
    </div>
)
